<template>
  <div>
    <div class="header-content">
      <div>
        <span>我的寝室</span>
      </div>
      <div style="text-align: center;margin-top: 20px;">
        <span class="dorm-text">{{dormName}}</span>
      </div>
      <div class="dorm-mesage">{{userName}}</div>
      <div class="project">
        <div class="weui-flex">
          <div class="weui-flex__item"><div class="placeholder project-main-text active" style="border-radius: 20px 20px 20px 20px;border-right: 1px solid #dadada;">{{currentUser.id?'剩余电量: ' + (currentUser.allAmp - currentUser.usedAmp).toFixed(2) + '度':'登录后显示剩余电量'}}</div></div>
          <!-- <div class="weui-flex__item"><div class="placeholder project-main-text" style="border-right: 1px solid #dadada;"></div></div>
          <div class="weui-flex__item"><div class="placeholder project-main-text"></div></div> -->
        </div>
      </div>
    </div>
    <div class="fee-content">
      <div class="mesage">*支付完成后，预计5分钟后冲入电控系统，请刷新查看最新剩余电量</div>
      <div class="fee-content-1">
        <div style="width: 20%;display: inline-block;font-size: 20px;font-weight: 700;">金额: </div>
        <div style="width: 79%;display: inline-block;border-radius: 20px;border: 1px solid #f1f1f1;" >
          <input type="tel" maxlength="4" v-model="amount">
          <div style="width: 17%;display: inline-block;font-size: 35px;">￥</div>
        </div>
      </div>
    </div>
    <div style="text-align: center;margin-top: 45px;">
      <button class="recharge-btn" @click="recharge">充值</button>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex'
import weui from 'weui.js';
export default {
  name: 'container',
  data() {
    return {
      amount: null
    }
  },
  computed: mapState({
    dormName: state => state.user.currentUser.loudong + state.user.currentUser.room,
    userName: state => state.user.currentUser.name,
    currentUser: state => state.user.currentUser
  }),
  async created() {
    console.log(this.currentUser)
    if(!this.currentUser.id){
      try {
        let resp = await this.$store.dispatch({type: 'user/currentUser'})
        console.log(resp)
        if (!resp.bindFlag) {
          this.$router.replace({path: "mine"})
        }
      } catch (e) {
        weui.alert("登录失败，请联系后勤", {
          className: "fm-border"
        })
      }
    }else{
      let resp = await this.$store.dispatch({type: 'user/currentUser'})
      console.log(resp)
    }
  },
  methods: {
    async recharge() {
      if(!this.amount){
        weui.alert("请输入充值金额", {
          className: "fm-border"
        })
        return;
      }
      var loadingEl = weui.loading('支付中');
      let orderResult = await this.$store.dispatch({type: 'trade/getOrder', data: {amount: this.amount * 100}})
      loadingEl.hide(() => {
        window.WeixinJSBridge.invoke(
          'getBrandWCPayRequest', orderResult,
          (res) => {
              if (res.err_msg == "get_brand_wcpay_request:ok" ) {
                  weui.alert('恭喜您，支付成功', () => {
                    this.$router.replace({path: "history"})
                    },{
                        title: '支付成功'
                    }
                  );
              }
          }
        ); 
      })
    }
  }
}
</script>

<style scoped>
  .header-content{
    background: #4953cf;
    border-radius: 0px 0px 20px 20px;
    min-height: 220px;
    color: white;
    padding: 30px;
  }
  .header-content span{
    font-weight: 600;
  }
  .dorm-text{
    font-size: 30px;
  }
  .dorm-mesage{
    text-align: center;
    font-size: 16px;
    margin-top: 20px;
    font-weight:600;
  }
  .mesage{
    text-align: center;
    font-size: 10px;
    margin-top: 20px;
  }
  .project{
    margin-top: 30px;
    background: white;
    color: #000;
    border-radius: 20px;
    text-align: center;
  }
  .project-main-text{
    color: #4b52aa;
    font-size: 18px;
    font-weight: 500;
    height: 70px;
    line-height: 70px;
  }
  .fee-content{
    margin-left: 30px;
    margin-right: 30px;
    margin-top: 36px;
  }
  .fee-content-1{
    margin-top: 40px;
  }
  .fee-content-1 input{
    height: 40px;
    width: 80%;
    font-size: 35px;
    text-align: right;
  }
  .recharge-btn{
    height: 40px;
    width: 290px;
    background: #363fa3;
    color: white;
    font-weight: 500;
    border-radius: 20px;
    font-size: 18px;
  }
  .active{
    background: #f1f1f1;
  }
</style>